var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-category-manager-details',{attrs:{"uuid":_vm.uuid,"edit-route-name":"ecommerce-categories-update","ecommerce":""}})}
var staticRenderFns = []

export { render, staticRenderFns }